module.exports = __webpack_public_path__ + "img/steering.95189582.png";